/* Imports */
import { Formie } from '../../../vendor/verbb/formie/src/web/assets/frontend/src/js/formie-lib';
import { applyCalendarTheme, bindCalendarOpening } from '@js/helpers/CalendarTheme';

class Forms {
    constructor() {
        this.attr = 'data-formie';
        // Formie's date fields dispatch this before constructing their Flatpickr picker.
        document.addEventListener('beforeInit', (event) => {
            const options = event.detail?.options;
            if (!event.detail?.datepicker || !options) return;

            const source = event.target;
            const applyTheme = (dates, dateStr, instance) => {
                applyCalendarTheme(instance.calendarContainer, source);
            };
            for (const hook of ['onReady', 'onOpen']) {
                const existing = options[hook];
                options[hook] = [
                    ...(Array.isArray(existing) ? existing : existing ? [existing] : []),
                    applyTheme,
                    ...(hook === 'onReady' ? [(_dates, _dateStr, instance) => bindCalendarOpening(instance)] : []),
                ];
            }
        });
        this.FormieInstance = new Formie();

        document.addEventListener('onFormieInit', (event) => {
            // Fetch the Form Factory once it's been loaded
            let form = event.detail.formie;
            let formId = event.detail.formId;
            let formEl = event.detail.$form;

            if (!formEl?.hasAttribute(this.attr)) return;

            // Refresh the necessary bits that are statically cached (CSRF inputs, captchas, etc)
            this.update(form, formId);

            if (formEl.getAttribute('data-form-submit-method') !== 'ajax') {
                formEl.addEventListener('onAfterFormieSubmit', (e) => {
                    //e.preventDefault();

                    this.update(form, formId);
                });
            }
        });
    }

    async init() {
        // Barba does not execute Craft's inline CSRF script on incoming pages.
        await this.refresh();
        this.FormieInstance.initForms(false);
    }

    update(form, formId) {
        form.refreshForCache(formId);
    }

    destroyForms() {
        // Barba may have removed the old DOM; destroy the factory's tracked instances.
        return Promise.all([...this.FormieInstance.forms].map(form =>
            this.FormieInstance.destroyForm(form)
        ));
    }

    async refresh() {
        const formEls = [...document.querySelectorAll(`[${this.attr}]`)]
            .filter(form => form.querySelector('craft-csrf-input'));

        if (!formEls.length) return;

        const response = await fetch('/actions/users/session-info', {
            headers: { 'Accept': 'application/json' },
        });

        if (!response.ok) throw new Error(`CSRF refresh failed (${response.status})`);

        const data = await response.json();
        if (!data.csrfTokenName || !data.csrfTokenValue) {
            throw new Error('CSRF refresh returned no token');
        }

        formEls.forEach(form => {
            // Craft's own script may have replaced the placeholder while we fetched.
            form.querySelectorAll('craft-csrf-input').forEach(csrfTag => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = data.csrfTokenName;
                input.value = data.csrfTokenValue;
                csrfTag.replaceWith(input);
            });
        });
    }
}

export default new Forms();
